import { render, staticRenderFns } from "./FeatureCardBasic.vue?vue&type=template&id=452959db&"
import script from "./FeatureCardBasic.vue?vue&type=script&lang=js&"
export * from "./FeatureCardBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports